import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import * as actionsCalendarioFeriado from '../../../store/calendarioFeriado/actions';
import {
  DialogDefaultV2,
  InputV2,
  DatePickerV2,
  DefaultSelectV2,
  EstadoInputV2,
  MunicipioSelectV2,
} from '../../../components/v2';

const TIPO_OPTIONS = [
  { id: 'NACIONAL', nome: 'Nacional' },
  { id: 'ESTADUAL', nome: 'Estadual' },
  { id: 'MUNICIPAL', nome: 'Municipal' },
];

const schema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  uf: (value, attributes) =>
    attributes.tipo && attributes.tipo !== 'NACIONAL'
      ? { presence: { allowEmpty: false, message: 'é obrigatório' } }
      : null,
  codigoIbge: (value, attributes) =>
    attributes.tipo === 'MUNICIPAL'
      ? { presence: { allowEmpty: false, message: 'é obrigatório' } }
      : null,
};

const Formulario = ({ criarFeriado, atualizarFeriado, row, open, id, onClose }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id && row) {
      setValues(row);
    } else if (!id) {
      setValues({});
    }
  }, [id, row]);

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros || {});
    if (erros) return;

    const callback = (ok) => {
      if (ok) onCloseLocal(true);
    };

    if (values.id) {
      atualizarFeriado(values, callback);
    } else {
      criarFeriado(values, callback);
    }
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleTipoChange = (event) => {
    const tipo = event.target.value;
    setValues((prev) => ({
      ...prev,
      tipo,
      ...(tipo === 'NACIONAL' ? { uf: null, codigoIbge: null } : {}),
      ...(tipo === 'ESTADUAL' ? { codigoIbge: null } : {}),
    }));
  };

  const isEditing = !!values.id;

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title={isEditing ? 'Editar Feriado' : 'Novo Feriado'}
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <DatePickerV2
            error={!!(errors && errors.data)}
            isRequired
            label="Data"
            onChange={(value) => setValues({ ...values, data: value })}
            value={values.data}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.nome)}
            isRequired
            label="Nome"
            name="nome"
            onChange={handleChange}
            value={values.nome || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <DefaultSelectV2
            error={!!(errors && errors.tipo)}
            isRequired
            label="Tipo"
            name="tipo"
            disabled={isEditing}
            options={TIPO_OPTIONS}
            optionLabel="nome"
            onSelect={handleTipoChange}
            value={values.tipo || ''}
          />
        </Grid>
        {values.tipo && values.tipo !== 'NACIONAL' && (
          <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
            <EstadoInputV2
              error={!!(errors && errors.uf)}
              isRequired
              estado={values.uf}
              onSelect={(uf) => setValues({ ...values, uf })}
            />
          </Grid>
        )}
        {values.tipo === 'MUNICIPAL' && (
          <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
            <MunicipioSelectV2
              error={!!(errors && errors.codigoIbge)}
              isRequired
              value={values.codigoIbge}
              nome={values.municipioNome}
              uf={values.uf}
              onSelect={(municipio) =>
                setValues({
                  ...values,
                  codigoIbge: municipio ? municipio.codigoIbge : null,
                  municipioNome: municipio ? municipio.nomeOriginal : null,
                })}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={4}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  criarFeriado: PropTypes.func.isRequired,
  atualizarFeriado: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  row: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

Formulario.defaultProps = {
  id: null,
  row: null,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsCalendarioFeriado,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(withRouter(Formulario));
